import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            lowBorder: anyImageOpResult,
            highBorder: anyImageOpResult,
            mask: anyImageOpResult,
            useLaplacianBlending: z.boolean().optional().default(true),

            debugDrawEnabled: z.boolean().optional().default(false),
            testParam1: z.number().optional(),
            testParam2: z.number().optional(),
        }),
    },
}
